import React, { useState } from 'react'
import { withStyles, createStyles } from '@mui/styles'
import { Paper, Typography } from '@mui/material'
import { muiOptions, MuiProps, defaultStyles, defaultColors } from '../../../infrastructure/materialUiThemeProvider'
import { t } from '../../../infrastructure/i18nextHelper'
import { navigateTo } from '../../../infrastructure/navigation'
import { CustomButton } from '../../common/components/button'
import { DataTable } from '../../common/customComponents'
import { StockProjection } from '../stockModels'
import { projectionColumnStyles, useProjectionColumns } from '../projectionColumns'
import { SimulationMktSalesPopup } from './simulationPopup'

function _SimulationTable({ classes }: MuiProps) {
    let { store, simulationStore, columns } = useProjectionColumns(classes, true)
    let [isMktSalesPopupOpen, setIsMktSalesPopupOpen] = useState<boolean>(false)

    let SimulationDataTable = DataTable as React.ComponentType<any>

    return (
        <Paper className={classes.container}>
            <div className={classes.header}>
                <Typography className={classes.title} variant='overline' display='block' gutterBottom>
                    {t('stock.label.simulationButton')}
                </Typography>
                <div>
                    <CustomButton
                        label={t('stock.simulation.mktSalesPopup.open')}
                        onClick={() => setIsMktSalesPopupOpen(true)}
                        className={classes.secondaryButton}
                    />
                    {simulationStore.simulations.length > 0 ?
                        <CustomButton
                            label={t('stock.label.clearSimulation')}
                            onClick={() => simulationStore.clearSimulation()}
                            tourKey='stockProjectionTableCancelSimulation'
                            className={classes.secondaryButton}
                        />
                        : undefined}
                    <CustomButton
                        label={t('stock.label.exitSimulationButton')}
                        onClick={() => {
                            simulationStore.clearSimulation()
                            navigateTo('/stock')
                        }}
                        className={classes.secondaryButton}
                    />
                </div>
            </div>
            <div className={classes.table}>
                <SimulationDataTable
                    isSelectable={false}
                    idSelector={(projection: StockProjection) => projection.date}
                    items={store.stockProjectionResult.values ?? []}
                    columns={columns}
                />
            </div>
            <SimulationMktSalesPopup isOpen={isMktSalesPopupOpen} setIsOpen={setIsMktSalesPopupOpen}
                projections={store.stockProjectionResult.values ?? []} />
        </Paper>
    )
}

let styles = _ =>
    createStyles({
        ...projectionColumnStyles,
        container: {
            height: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            padding: '0.5em 0'
        },
        header: {
            ...defaultStyles.flexRow,
            alignItems: 'center',
            justifyContent: 'space-between',
            margin: '0.2em 1em'
        },
        title: {
            color: defaultColors.grey.dark.color,
            margin: '0'
        },
        secondaryButton: {
            ...defaultStyles.secondaryButton,
            marginLeft: '1em'
        },
        table: {
            height: '100%',
            width: '100%',
            overflowY: 'auto',
            overflowX: 'hidden'
        }
    })

export let SimulationTable = withStyles(styles, muiOptions)(_SimulationTable)